import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, Dictionary } from '@softline/core';
import {
  SOFTLINE_API_GARAGE_ROSTER_CONTENT_ENTRY,
  SOFTLINE_API_GARAGE_ROSTER_DEPARTMENT_HEADS,
} from '../garage.api';
import { Mechanic } from '../models/mechanic';

export interface RosterDepartmentHead {
  employee: { id: number; key: string; name: string };
  managedDepartments: { id: number; key: string; name: string }[];
}

@Injectable()
export class AgendaRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown> | null,
    queryParams?: Dictionary<unknown> | null
  ): ApiResourceLocation {
    const location: ApiResourceLocation = { path };
    if (pathParams) {
      location.pathParams = pathParams;
    }
    if (queryParams) {
      location.queryParams = queryParams;
    }
    return location;
  }

  retrieve(headId: string, mechanicId: string, date: string): Promise<Mechanic[]> {
    return this.#dataAccess.get(
      this.createLocation(
        SOFTLINE_API_GARAGE_ROSTER_CONTENT_ENTRY,
        { id: headId },
        {
          enddate: date.split('T')[0],
          begindate: date.split('T')[0],
          employeeIdPerson: mechanicId,
        }
      )
    );
  }

  getDepartmentHead(date: string): Promise<RosterDepartmentHead[]> {
    return this.#dataAccess.get(
      this.createLocation(SOFTLINE_API_GARAGE_ROSTER_DEPARTMENT_HEADS, null, {
        cutoffdate: date.split('T')[0],
      })
    );
  }
}
